<template>
  <div class="radio-button relative">
    <input 
      type="radio" 
      :name="name" 
      :id="id" 
      :value="value"
      :checked="checked"
      @change="handleChange"
      class="absolute opacity-0"
    />
    <label 
      :for="id" 
      class="block pl-11 pr-8 py-1 cursor-pointer relative z-10 font-semibold text-sm leading-9 uppercase transition-colors duration-300"
      style="font-family: 'Arial Regular', sans-serif; color: #6891AC;"
    >
      {{ label }}
    </label>
    <div class="checker absolute top-1 left-0 w-7 h-7 border-2 rounded-full z-0 transition-all duration-300" :class="checkerClasses">
      <div class="circle-button w-3.5 h-3.5 rounded-full transition-all duration-300 relative" :class="circleClasses" :style="circleStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkerClasses() {
      return this.checked 
        ? 'border-primview-400' 
        : 'border-gray-400'
    },
    circleClasses() {
      return this.checked 
        ? 'bg-primview-400 opacity-100' 
        : 'bg-gray-400 opacity-40'
    },
    circleStyle() {
      return {
        // top: 'calc((28px / 2) - (14px / 2))',
        top: '5px',
        // left: 'calc((28px / 2) - (14px / 2))'
        left: '5px'
      }
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event)
    }
  }
}
</script>

<style scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
